
export const changedFieldNamesToDisplay = ['Procedure Date', 'Procedure Time',  'Surgery date',
	'Surgery time', 'Equipment', 'Authorization', 'FIN #'];

export const documentActions = ['Added', 'Deleted'];
